/* eslint-disable yoda */
import { useState, useEffect } from 'react';

export const useBreakpoints = () => {
  const getBreakpoint = () =>
    [576, 768, 992, 1200].filter((n) => n <= window.innerWidth).length;

  const [bp, setBP] = useState(-1);

  useEffect(() => {
    const handleResize = () => {
      setBP(getBreakpoint());
    };

    window.addEventListener('resize', handleResize);
    handleResize();
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return {
    xs: 0 <= bp,
    sm: 1 <= bp,
    md: 2 <= bp,
    lg: 4 <= bp,
    xl: 5 <= bp,
  };
};

export const useSize = (debounce_frequency = 0) => {
  const [width, setWidth] = useState(window.innerWidth);
  const [height, setHeight] = useState(window.innerHeight);

  useEffect(() => {
    let i = null;
    const handleResize = () => {
      if (i) {
        clearTimeout(i);
      }
      i = setTimeout(() => {
        if (width !== window.innerWidth) {
          setWidth(window.innerWidth);
        }
        if (height !== window.innerHeight) {
          setHeight(window.innerHeight);
        }
        i = null;
      }, debounce_frequency);
    };

    window.addEventListener('resize', handleResize);
    handleResize();
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [height, width, debounce_frequency]);

  return { width, height };
};
